module.exports = __webpack_public_path__ + "static/media/434013427_1173587760327464_1218719914600976283_n_optimized_.ef3360a1.jpg";